import { Alert, Snackbar } from "@mui/material";
import React from "react";

function Toast(props) {
  const { error, message, onClose, success, autoHide } = props;

  return (
    <Snackbar
      open={error || success}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      onClose={onClose}
      autoHideDuration={autoHide}
    >
      <div>
        {error && (
          <Alert severity="error" variant="filled" onClose={onClose}>
            {message}
          </Alert>
        )}
        {success && (
          <Alert color="success" variant="filled" onClose={onClose}>
            {message}
          </Alert>
        )}
      </div>
    </Snackbar>
  );
}

export default Toast;
